import { Component, OnInit, ViewChild, input } from '@angular/core';

@Component({
    selector: 'mutara-component-list',
    templateUrl: './component-list.component.html',
    standalone: false
})
export class ComponentListComponent implements OnInit {

  readonly components = input<any[]>(undefined);
  readonly actions = input<any[]>(undefined);

  constructor() { }
  ngOnInit(): void {
  }

}
